import dashboard from './reducers/dashboard/dashboardSlice';
import administer from './reducers/administer/administerSlice';

export default {
    dashboard: {
        reducer: dashboard,
    },
    administer: {
        reducer: administer,
    },
};
